import { EUserPermissions } from '@zunta/configurations'

const meta = {
  requiresAuth: true,
  managementOnly: true
}

export default [
  {
    name: 'management-resident-payment',
    path: 'residents/:residentId/payment',
    component: () => import('@/views/app/payment/Payment.vue'),
    meta: {
      requiresAuth: true
    },
    redirect: { name: 'payment-one-time' },
    children: [
      {
        name: 'payment-one-time',
        path: 'one-time-payment',
        component: () => import('@/views/app/payment/one-time/OneTime.vue'),
        meta: { ...meta, permissions: [EUserPermissions.MAKE_PAYMENT] }
      },
      {
        name: 'payment-autopay',
        path: 'autopay',
        component: () => import('@/views/app/payment/autopay/Autopay.vue'),
        meta: { ...meta, permissions: [EUserPermissions.MAKE_PAYMENT, EUserPermissions.CREATE_AUTOPAY] }
      },
      {
        name: 'edit-payment-autopay',
        path: 'edit-autopay/:settingId',
        component: () => import('@/views/app/payment/autopay/Autopay.vue'),
        meta: { ...meta, permissions: [EUserPermissions.MAKE_PAYMENT, EUserPermissions.CREATE_AUTOPAY] }
      },
      {
        name: 'payment-one-time-success',
        path: 'one-time-payment/success/:paymentId',
        component: () => import('@/views/app/payment/one-time/OneTimeSuccess.vue'),
        meta: { ...meta, permissions: [EUserPermissions.MAKE_PAYMENT] }
      },
      {
        name: 'payment-one-time-failure',
        path: 'one-time-payment/fail/:paymentId',
        component: () => import('@/views/app/payment/one-time/OneTimeFailure.vue'),
        meta: { ...meta, permissions: [EUserPermissions.MAKE_PAYMENT] }
      },
      {
        name: 'refund-success',
        path: 'refund/success/:paymentId',
        component: () => import('@/views/app/payment/one-time/OneTimeSuccess.vue'),
        meta: { ...meta, permissions: [EUserPermissions.MAKE_PAYMENT] }
      },
      {
        name: 'payment-autopay-success',
        path: 'autopay/success/:scheduleId',
        component: () => import('@/views/app/payment/autopay/AutopaySuccess.vue'),
        meta: { ...meta, permissions: [EUserPermissions.MAKE_PAYMENT, EUserPermissions.CREATE_AUTOPAY] }
      },
      {
        name: 'payment-one-time-edit',
        path: 'edit/:paymentId',
        component: () => import('@/views/app/payment/one-time/EditPayment.vue'),
        meta: { ...meta, permissions: [EUserPermissions.MAKE_PAYMENT] }
      }
    ]
  },
  {
    name: 'management-payments-review',
    path: 'review/:section?/:scheduleItemId?',
    component: () => import('@/views/app/management/payments/review/PaymentsReview.vue'),
    meta: {
      requiresAuth: true,
      permissions: [EUserPermissions.VIEW_PAYMENTS, EUserPermissions.VIEW_AUTOPAY]
    }
  },
  {
    name: 'hmo-payment-approved',
    path: 'payments/hmo-payment-approved/:id',
    component: () => import('@/views/app/management/payments/components/HMOPaymentApproved.vue')
  },
  {
    name: 'hmo-payment-declined',
    path: 'payments/hmo-payment-declined/:id',
    component: () => import('@/views/app/management/payments/components/HMOPaymentDeclined.vue')
  },

  {
    meta: { ...meta, permissions: [EUserPermissions.VIEW_PAYMENTS] },
    path: 'payments',
    name: 'management-payments',
    component: () => import('@/views/app/management/payments/Payments.vue'),
    redirect: {
      name: 'management-payments-sections-needs-review'
    },
    children: [
      {
        path: 'needs-review',
        meta: { ...meta, permissions: [EUserPermissions.VIEW_PAYMENTS] },
        name: 'management-payments-sections-needs-review',
        component: () => import('@/views/app/management/payments/sections/PaymentsNeedsReview.vue')
      },
      {
        path: 'processed',
        meta: { ...meta, permissions: [EUserPermissions.VIEW_PAYMENTS] },
        name: 'management-payments-sections-processed',
        component: () => import('@/views/app/management/payments/sections/PaymentsProcessed.vue')
      },
      {
        path: 'deposits',
        meta: { ...meta, permissions: [EUserPermissions.VIEW_DEPOSITS] },
        name: 'management-payments-sections-deposits',
        component: () => import('@/views/app/management/payments/sections/PaymentsDeposits.vue')
      }
    ]
  }
]
